"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FallbackVideoPlugin = exports.VIDEO_PATTERNS = void 0;
const base_1 = require("../base");
exports.VIDEO_PATTERNS = [
    // Phoenix
    'm-detail--feature-video',
    'm-video-unit',
    'mm-widget--sendtonews',
    'phoenix-exco-player',
    'tml-external-provider="jwplayer"',
    'tml-external-provider="stn"',
    'tml-video',
    // Raven
    'wp-block-jw-player-video',
    'wp-block-embed-youtube',
];
class FallbackVideoPlugin extends base_1.BasePlugin {
    constructor() {
        super(...arguments);
        this.videoPatterns = exports.VIDEO_PATTERNS;
        this.defaultConfig = {
            injectOn: ['A'],
            maxInjections: 1,
            videoRegex: new RegExp(`${this.videoPatterns.join('|')}`, 'm'),
            visibleOn: ['A', 'B', 'C', 'D'],
        };
    }
    generateMarkup(config) {
        const { playerId, type } = config;
        const data = JSON.stringify({ playerId, type }).replace(/"/g, '&quot;');
        return `<div
            data-smart-slot="fallback-video"
            data-smart-slot-config="${data}"
        ></div>`;
    }
}
exports.FallbackVideoPlugin = FallbackVideoPlugin;
//# sourceMappingURL=index.js.map